import type { SxProps, Theme } from '@mui/material';

export const styles = {
    triggerBox: (theme: Theme): SxProps<Theme> => ({
        display: 'flex',
        alignItems: 'center',
        border: `1px solid ${theme.palette.grey[100]}`,
        borderRadius: '8px',
        height: 32,
        px: 1,
        gap: 1,
        cursor: 'pointer',
        backgroundColor: 'white',
        width: 160,
        flex: '0 0 160px',
        overflow: 'hidden',
    }),
    label: {
        fontSize: '12px',
        color: 'grey.900',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        flex: 1,
        minWidth: 0,
    } as SxProps<Theme>,
};
